export const decodePackagePolicy = (projectPolicy) => {
    return {
        contractorPackageId: projectPolicy.contractor_package_id,
        created: new Date(projectPolicy.created),
        id: projectPolicy.package_policy_id,
        projectId: projectPolicy.project_id,
        projectPolicyId: projectPolicy.project_policy_id
    };
};
export const encodePackagePolicy = (projectPolicy) => {
    return {
        contractor_package_id: projectPolicy.contractorPackageId,
        created: projectPolicy.created,
        package_policy_id: projectPolicy.id,
        project_id: projectPolicy.projectId,
        project_policy_id: projectPolicy.projectPolicyId
    };
};
